import React from 'react';
import Modal from 'react-responsive-modal';
import _ from 'lodash';
import ReactTable from "react-table";
import Translate from 'translate';

class Map extends React.Component {
  constructor( props ) {
    super( props );
  }

  render() {
    const { data, onClose, open } = this.props;

    return (
      <Modal little
             modalClassName="col-md-8 max-width-unset client-folder"
             open={open}
             onClose={onClose}>
        <iframe src={data} width="100%" height={500}/>
      </Modal>
    )
  }
}

module.exports = Map;



// WEBPACK FOOTER //
// ./routes/app/components/Agent/ClientFolder/MapModal/index.js